export default {
  isLoading: false,
  hasLoaded: false,
  error: null,

  balanceSheet: [],

  isLoadingEBalance: false,

  isPostingDeepAnalyzeReport: false,
  isPostingEBalance: false,
  isLoadingBalanceSheetPdfExport: false,
  isLoadingBalanceSheetXlsExport: false,

  meta: {
    availableLevels: [],
  },
};
